const Locale = {
  document_title: "Панель замовлень - QRWaiter",
  choose_language: "Виберіть мову:",
  login: {
    title: "Вхід в чергу замовлень",
    enter_qid_pin: "Введіть qID закладу та Ваш PIN-код",
    qid_ph: "ID закладу",
    enter_pin: "PIN-код",
    enter_shared: "Загальна черга",
  },
  navbar: {
    queue: "Черга замовлень",
    archive: "Історія чеків",
    tables: "Зали і столи",
    orders: "Замовлення",
    notifs: "Сповіщення",
    support: "Технічна підтримка",
    switch_new: "Перейти в нову версію",
    logout_confirm: "Ви дійсно хочете вийти з системи?",
    stoplist: "Стоп-лист",
    logout: "Вихід",
  },
  queue: {
    connecting_title:
      "Підключення до черги замовлень, будь ласка, зачекайте...",
    connecting_desc:
      "Якщо підключення триває дуже довго - спробуйте пізніше або зверніться до тех. підтримки.",
    create_order: "Створити нове замовлення",
    no_orders: "Замовлень в цій вкладці ще немає.",
    check_history: "Переглянути історію",
    creating_order_message: "Створення нового замовлення",

    shared_queue: "Загальна черга",
    not_your_order:
      "Ви не можете виконати цю дію над замовленням іншого офіціанта.",
    modes_not_setup:
      "Щоб отримати доступ до черги замовлень налаштуйте бажані режими в адмін. панелі закладу",
  },
  tabs: {
    new: "Нові",
    processing: "Виконуються",
    done: "Розрахунок",
    calendar: "Календар",
  },
  card: {
    client: "Клієнт:",
    total: "Всього:",
    comment: "Коментар:",
    discount: "Знижка:",
    pay_method: "Метод оплати:",
    reason: "Причина відмови:",

    append: "Дозамовлення",
    append_accepted_at: "Було прийнято {time} тому",
    append_accepted_now: "Було прийнто щойно",

    pay_methods: {
      cash: "Готівка",
      card: "Терміналом",
      online: "Онлайн",
      bonus: "Бонуси",
    },

    descriptions: {
      waiting: "Нове замовлення очікує:",
      serving: "Обслуговується:",
      serving_timer: "До подачі:",
      served: "Подано",
      paying: "Неоплачено...",
      executed: "Оплачено",
      editing: "Редагування",
    },

    pay_status: "Статус оплати:",
    paid: "Оплачено",
    unpaid: "Неоплачено",

    geolocation_not_verified:
      "Увага! Це замовленя не пройшло перевірку геолокації.",

    to_pay: "До сплати:",
  },
  waiting: {
    title: "Оберіть час приготування",
    title_hotel: "Оберіть час очікування",
    time: "хв",
    hours: "год",
    not_required: "Час приготування обирати не обов’язково",
    exact_time: "Вказати точний час",
  },
  status: {
    table_no: "Стіл",
    hall: "Зал",
    room: "Номер",
  },
  actions: {
    accept: "Прийняти",
    cancel: "Відхилити",
    pay: "Розрахувати",
    edit: "Редагувати замовлення",
    move: "Пересадити за інший стіл",
    options: "Опції",
    serve: "Подано",
    self_serve: "Готово",

    split: "Розділити чек",
    merge: `Об'єднати чек`,
    close: "Закрити чек",
    unlock: "Розблокувати",
    return: "Відмінити розрахунок",
    add_dish: "Додати страву",

    to_inside: "Перевести в INSIDE",

    unlock_desc1: "Клієнт оплачує замовлення онлайн.",
    unlock_desc2: "Цей чек буде закрито автоматично.",

    preorder_accept: "Прийняти",
    preorder_served: "Подано",
    preorder_sent: "Відправлено",
  },

  pay: {
    set_discount: "Встановити знижку:",
    by_cash: "Готівкою",
    by_card: "Терміналом",
  },

  add_dish: {
    title: "Оберіть страву або напій:",
    choose_modificators: "Оберіть додатки:",
    choose_variant: "Оберіть варіант:",
    add_to_cart: "Додати до чеку",
    add_many: "Чек",
    go_to_cart: "Перейти до чеку",
    dishes_count: "страва | страви",

    back: "Назад",
    add: "Додати",
  },

  choose_table: {
    title: "Виберіть стіл:",
    accept: "Вибрати стіл",
    small_hint: "Оберіть стіл",
    move: "Пересадити за вибраний стіл",
  },

  edit: {
    title: "Редагування чеку",
    add_dish: "Додати страву",

    cancel: "Відміна",
    save: "Зберегти",
  },

  merge: {
    title: `Об'єднання чеків:`,
    cancel: "Відміна",
    confirm: `Об'єданти`,
  },

  refuse: {
    title_some: "Ви відмовляєте клієнту в подачі {amount} страв(и)",
    title_all: "Ви відмовляєте клієнту в подачі всіх страв",

    enter_reason: "Ви скасовуєте замовлення",

    enter_reason_ph: "Напишіть причину",

    reasons: {
      stock: "Страв(и) немає",
      age: "Продаж алкоголю неповнолітнім особам заборонено",
      custom: "Інше",
    },

    delete_reason: "Офіціант видалив чек",

    refund_warning:
      "Увага: при скасуванні замовлення буде здійснено повернення коштів клієнту згідно правил платіжної системи Вашого закладу.",

    cancel: "Назад",
    confirm: "Скасувати замовлення",
  },

  split: {
    title: "Розбиття чеку",
    cancel: "Відміна",
    confirm: "Розділити",
  },

  create_order: {
    confirm: "Створити замовлення",
    cart: "Корзина",
    choose_dish: "Оберіть страву",
    check_order: "Перевірте правильність замовлення",
  },

  archive: {
    tabs: {
      cash: "Готівка",
      card: "Термінал",
      online: "Онлайн",
    },
    modes: {
      list: "Історія",
      summary: "Виписка",
    },
    no_checks: "Чеків в архіві з таким методом оплати ще немає.",
    pay_method: "Спосіб оплати:",

    summary: {
      total: "Всього:",
      discount: "Знижки видано на суму:",
      tips: "Чайові:",
    },
  },

  tables: {
    loading: "Завантаження...",
    loading_text: "Наші дизайнери малюють сітку для Ваших столів, зачекайте...",

    table_no: "Стіл №",

    titles: {
      move: "Перемістити",
      join: `Об'єднати`,
    },

    actions: {
      merge: `Об'єднати чеки`,
      join: `Об'єднати столи`,
      disjoin: `Роз'єднати столи`,
      move: "Пересадити за інший стіл",
      join_empty: `Об'єднати з іншим столом`,
    },

    action_messages: {
      merge: "Об’єднання столів",
      merge_description: "Оберіть стіл, з яким хочете об’єднати поточний стіл",
      move: "Переміщення чеку",
      move_description: "Оберіть стіл, на який хочете перемістити чек",
    },

    confirm: {
      move: "Пересадити",
      join: `Об'єднати`,
    },

    table_empty: "Пустий",

    noun_checks: {
      singular: "чек",
      plural: "чеки",
      plural_2: "чеків",
    },
  },
  preorder_card: {
    phone: "Моб. номер:",
    takeaway: "Клієнт хоче отримати замовлення о:",
    date: "Дата:",
    address: "Адреса:",
    serve_date: "Час видачі:",
    time: "Час:",

    serve_plus: "через",
    serve_minus: "тому",

    action_edit: "Редагувати",
    action_cancel: "Скасовано",

    wait_limit: "У Вас 15 хв, щоб прийняти замовлення.",
    send_desc:
      "Відмітьте замовлення як відправлене, щоб гість отримав сповіщення",
    delivery_autoclose:
      "Чек закриється автоматично, після того як замовлення буде доставлено.",
    preorder_autoclose: "Чек закриється автоматично через 30 с.",

    action_close: "Закрити замовлення",

    takeaway_warning:
      "Увага! Це попереднє замовлення, зверніть увагу на час отримання.",

    paid_by_bonuses: "Замовлення оплачене бонусним рахунком.",

    with_takeaway: "З собою",
    with_reservation: "+ бронь столика",

    delivery_cost: "+ Доставка",
    delivery_cost_taxi: "+ Доставка, яка оплачується додатково при отриманні",
  },
  delivery_order_car: {
    title: "Машина буде через:",
    action: "Замовити машину",
  },
  delivery_driver: {
    title: "Інформація про водія:",
    phone: "Моб. номер",
    car: "Номер авто:",
    warning: "Жоден водій не прийняв замовлення. Телефон диспетчера доставки:",
  },
  errors: {
    title:
      "Сталася помилка при виконанні операції. Будь-ласка, оновіть сторінку або перезайдіть в чергу замовлень.",
    codes: {},
  },
  friendly_dates: {
    today: "Сьогодні",
    tomorrow: "Завтра",
  },
  create_preorder: {
    name_ph: `Ім'я`,
    address_ph: "Адреса",
    date_ph: "Оберіть дату та час",
    asap: "Якнайшвидше",
    no_guests: "Без приборів",
    payment_ph: "Спосіб оплати",
    payment_cash: "Готівкою",
    payment_card: "Терміналом",
    to_order: "Перейти до замовлення",
    comment_ph: "Ви можете залишити додатковий коментар до замовлення. ",

    takeaway: "З собою",
    with_reservation: "+ бронь столика",

    fill_fields: "Заповніть всі поля.",
    create_btn: "Створити замовлення",

    details_types: {
      flat: "Квартира",
      floor: "Поверх",
      entrance: `Під'їзд`,
    },

    bonus_balance: "БОНУСНИЙ БАЛАНС",
  },
  reserve: {
    header: "Бронювання стола",
    card_guests_count: "особа | особи",
    card_reserve_time: "Час бронювання:",
    card_reserve_date: "Дата бронювання:",
    card_phone: "Моб. номер:",
    card_accept: "Прийняти",
    card_cancel: "Скасувати бронювання",
    card_accepted: "Стіл заброньовано, Вам також прийде нагадування завчасно.",
  },
  reserve_calendar: {
    today: "Сьогодні",
    yesterday: "Вчора",
    tomorrow: "Завтра",
  },
  units: {
    guests: "набір | набори",
    reserve_guests: "особа | особи",
    kg: "кг",
    g: "г",
    l: "л",
    ml: "мл",
  },
  preorder_status_bar: {
    accept_desc: "Для прийняття замовлення",
    accept_local: "Очікує прийняття",
    serve_desc: "До видачі",
    send_desc: "До відправлення",
    pay_status: "Статус оплати",
    paid: "Оплачено",
    unpaid: "Не оплачено",
    served: "Видано",
    sent: "Відправлено",
    creating: "Створення...",
  },
  inside_status_bar: {
    accept_desc: "Очікує підтвердження",
    serve_desc: "До подачі",
    served: "Подано",
    serving: "Готується...",
    splitting: "Розділення чеку...",
    editing: "Редагування...",
  },
  logout: {
    confirm: "Ви дійсно хочете вийти з панелі замовлень?",
  },
  item_list: {
    weight_input: "Вага",
  },
  delete_dish: {
    title: "Видалити страву?",
    confirm: "Продовжити",
    cancel: "Скасувати",
  },
  stoplist: {
    tab_editor: "МЕНЮ",
    tab_stoplist: "СТОП-ЛИСТ",
    search_ph: "Пошук...",

    type_dish: "Страва",

    stoplisted: "Додано в стоп-лист",
  },
};

export default Locale;
